import * as THREE from 'three'
import { Truck } from 'types/data'
import { TRUCK_TRANSPARENT_FALSE, TRUCK_DOOR, TRUCK_BLACK } from 'constants/threeConstants';

const truckFIlterReducer = (child: THREE.Object3D) => {
  if (TRUCK_TRANSPARENT_FALSE.includes(child.name)) {
    //@ts-ignore
    child.material.transparent = false
    //@ts-ignore
    child.material.needsUpdate = true;
  } else if (TRUCK_DOOR.includes(child.name)) {
    child.scale.set(1.010, 1.010, 1.010)
    child.rotation.set(0, -1.5, 0)
  } else if (TRUCK_BLACK.includes(child.name)) {
    //@ts-ignore
    child.material.color.set(0x000000)
  }
}

const truckFilterMaterial = (material: THREE.MeshPhongMaterial | THREE.MeshStandardMaterial) => {
  if(material) {
    //@ts-ignore
    material.roughness = 2
    //@ts-ignore
    material.metalness = 1
    material.needsUpdate = true;
  }
}

const hiddenFilter = (child: THREE.Object3D, list: string[]) => {
  if(list.includes(child.name)) {
    child.visible = false 
  }
}

export const truckFilter = (truck: THREE.Scene, data: Truck) => {
  truck.traverse(child => {
    //@ts-ignore
    truckFilterMaterial(child.material)
    truckFIlterReducer(child)
    hiddenFilter(child, data.hidden_meshes!)
  })
}